<template>
  <div id="app" class="animated fadeIn" style="animation-duration: 2.5s">
    <!--头部-->
    <!--导航栏-->
    <nav class="navbar navbar-expand-lg bg-dark navbar-dark">
      <div class="company_name">山西富垦电气有限责任公司</div>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsible">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="collapsible">
        <ul class="nav navbar-nav ms-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/home" @click="collapseNavbar"><h5><i class="fa fa-home fa-fw"></i>首页</h5></router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/company" @click="collapseNavbar"><h5><i class="fa fa-building fa-fw"></i>公司介绍</h5></router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/honors" @click="collapseNavbar"><h5><i class="fa fa-building fa-fw"></i>荣誉证书</h5></router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/products" @click="collapseNavbar"><h5><i class="fa fa-chain fa-fw"></i>产品中心</h5></router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/directions" @click="collapseNavbar"><h5><i class="fa fa-wrench fa-fw"></i>技术支持</h5></router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/about" @click="collapseNavbar"><h5><i class="fa fa-user-secret fa-fw"></i>联系我们</h5></router-link>
          </li>
        </ul>
      </div>
    </nav>
    <!--展示区-->
    <div id="show" class="animated slideInDown" style="animation-duration: 2.5s;">
      <router-view v-slot="{ Component }">
        <transition name="firstPage">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
    <div style="clear: both"></div>
    <!--页尾-->
    <div id="Footer">
      <div class="container-fluid"></div>
      <div class="row no-gutters">
        <div id="Footer_left" class="col-7">
          <span><span class="fa fa-map-marker"></span>&nbsp;地址：太原晋源区姚村镇洞儿沟村西仁线备战路1号</span><br>
          <span><span class="fa fa-user-o"></span>&nbsp;联系人：赵先生</span><br>
          <span><span class="fa fa-phone"></span>&nbsp;电话：400-9669918 <br>
          <span class="fa fa-mobile"></span>&nbsp;<span class="fa fa-wechat">&nbsp;</span>手机微信同号：13935137090 18536889888</span><br>
          <span>Copyright © 2019  山西富垦电气有限责任公司 保留所有权<a href="http://beian.miit.gov.cn/" target="_blank" style="color: #F1C671;"><br> <img src="../src/static/images/nie.gif">晋ICP备19010955号&nbsp;晋ICP备19010955号 - 1</a></span>
        </div>
        <div id="Footer_right" class="col-2">
          <img src="../src/static/images/WXFK.jpg" alt="" width="135" height="135">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';

export default {
  name: 'App',
  setup() {
    const collapsibleRef = ref(null);

    onMounted(() => {
      import('bootstrap/dist/js/bootstrap.bundle.min.js').then(() => {
        collapsibleRef.value = document.getElementById('collapsible');
        if (collapsibleRef.value) {
          console.log('Navbar collapse initialized successfully');
        } else {
          console.error('Navbar collapse element not found');
        }
      }).catch((error) => {
        console.error('Error importing Bootstrap:', error);
      });
    });

    const collapseNavbar = () => {
      if (collapsibleRef.value) {
        const bsCollapse = new bootstrap.Collapse(collapsibleRef.value, { toggle: true });
        bsCollapse.hide();
      }
    };

    return {
      collapseNavbar
    };
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  background-size: 100% 100%;
}

.company_name {
  height: 30px;
  font-size: 22px;
  color: #ffffff;
  font-weight: bold;
}

/*导航栏*/
ul li {
  display: block;
  list-style: none;
  line-height: 30px;
  color: whitesmoke;
}

ul li a {
  color: #ffffff;
}

nav {
  text-align: center;
}

nav ul>li:hover {
  border-radius: 10px;
  background-color: snow;
  transition: all 0.5s linear;
  transform: translateY(-2px);
  box-shadow: 5px 5px 12px 5px #808080;
}

nav ul li a:hover {
  color: #F48D1A !important;
  font-weight: bolder;
}

.firstPage-enter-active,
.firstPage-leave-active {
  transition: opacity .5s;
}

.firstPage-enter,
.firstPage-leave-active {
  opacity: 0;
}

#show {
  margin-top: -1px;
  transition: width 4s;
  height: auto;
}

#Footer {
  width: 100%;
  background: url("../src/static/images/footer.jpg");
  background-size: 100% 100%;
  text-align: center;
  height: 330px;
  font-size: 30px;
  color: #F1C671;
  padding-top: 55px;
}

#Footer_left {
  font-size: 20px;
}

@media(min-width: 340px) {
  .company_name {
    font-size: 18px;
  }
  #Footer_left {
    font-size: 12px;
  }
}

@media (min-width: 360px) {
  #Footer_left {
    font-size: 10px;
  }
}

@media (min-width: 768px) {
  #Footer_left {
    font-size: 20px;
  }
}

@media (min-width: 992px) {
  #Footer_left {
    font-size: 23px;
  }
}

@media (min-width: 1200px) {
  #Footer_left {
    font-size: 27px;
  }
}
</style>